import { jsx, Fragment } from 'react/jsx-runtime';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const ReCaptchaProvider = ({ children, siteKey, disabled = false, ...props })=>{
    if (disabled || siteKey == null || siteKey === '') {
        return jsx(Fragment, {
            children: children
        });
    }
    return jsx(GoogleReCaptchaProvider, {
        reCaptchaKey: siteKey,
        useEnterprise: true,
        ...props,
        children: children
    });
};

export { ReCaptchaProvider };
//# sourceMappingURL=provider.js.map
